
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 1479","xmlns":"http://www.w3.org/2000/svg","width":"27.498","height":"27.498"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Rectangle 1618","fill":"#005f9e","d":"M12.031 0h3.437v27.498h-3.437z"}}),_c('path',{attrs:{"data-name":"Rectangle 1619","fill":"#005f9e","d":"M27.498 12.03v3.437H0V12.03z"}})])
          )
        }
      }
    